export default {
  colors: {
    text: 'rgb(22, 24, 28)',
    highlight: 'rgb(255, 80, 77)',
    highlightclockson: '#2988CC',
    highlightswr: '#2988CC',
    highlightmental: '#df3992',
    highlightkymo: '#4fb6fb',
    highlightnullLeasing: '#fd5720',
    background: '#16181C',
    backgroundclockson: '#3DA7FF',
    backgroundswr: '#00A7E7',
    backgroundkymo: '#f6f6f6',
    backgroundnullLeasing: '#f6f6f6'
  },
  breakpoints: {
    min2560: 2560,
    min1920: 1920,
    min1440: 1440,
    min1024: 1024,
    min768: 768,
    min640: 640,
    min480: 480,
    min360: 360
  }
}



// WEBPACK FOOTER //
// ../constants/theme.js